import _asyncToGenerator from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _extends from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutPropertiesLoose from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js";
var _excluded = ["children", "name", "isJoy", "isolated"],
  _excluded2 = ["children", "iframe", "id", "name", "onResetDemoClick", "isJoy", "isolated"];
import _regeneratorRuntime from "/opt/build/repo/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/regenerator/index.js";
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { prefixer } from 'stylis';
import rtlPlugin from '@mui/stylis-plugin-rtl';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { StyleSheetManager } from 'styled-components';
import { ThemeProvider as SystemThemeProvider } from '@mui/system';
import { extendTheme, useColorScheme as useJoyColorScheme } from '@mui/joy/styles';
import { createTheme, useTheme, styled } from '@mui/material/styles';
import GlobalStyles from '@mui/material/GlobalStyles';
import DemoErrorBoundary from 'docs/src/modules/components/DemoErrorBoundary';
import { useTranslate } from '@mui/docs/i18n';
import { unstable_useEnhancedEffect as useEnhancedEffect } from '@mui/utils';
import { DemoInstanceThemeProvider } from 'docs/src/theming';
import { ThemeOptionsContext } from 'docs/src/modules/components/ThemeContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var globalInjectThemeCache;
function JoyIframeObserver(_ref) {
  var document = _ref.document,
    isolated = _ref.isolated;
  var _useJoyColorScheme = useJoyColorScheme(),
    mode = _useJoyColorScheme.mode,
    systemMode = _useJoyColorScheme.systemMode;
  React.useEffect(function () {
    if (!isolated) {
      document.documentElement.setAttribute('data-joy-color-scheme', systemMode || mode);
    }
  }, [document, mode, systemMode, isolated]);
  return null;
}
JoyIframeObserver.propTypes = {
  document: PropTypes.object.isRequired,
  isolated: PropTypes.bool
};
function FramedDemo(props) {
  var _iframeTheme$generate;
  var children = props.children,
    document = props.document,
    isJoy = props.isJoy,
    isolated = props.isolated;
  var themeOptions = React.useContext(ThemeOptionsContext);
  var theme = useTheme();
  React.useEffect(function () {
    if (!isolated) {
      document.body.setAttribute('dir', theme.direction);
      document.documentElement.style.colorScheme = themeOptions.paletteMode;
      document.documentElement.setAttribute('data-mui-color-scheme', themeOptions.paletteMode);
    }
  }, [document, isolated, theme.direction, themeOptions.paletteMode]);
  var cache = React.useMemo(function () {
    return createCache({
      key: "iframe-demo-".concat(theme.direction),
      prepend: true,
      container: document.head,
      stylisPlugins: theme.direction === 'rtl' ? [prefixer, rtlPlugin] : [prefixer]
    });
  }, [document, theme.direction]);
  var getWindow = React.useCallback(function () {
    return document.defaultView;
  }, [document]);

  // This theme only used for generating CSS variables, NOT with the React context (ThemeProvider).
  var iframeTheme = React.useMemo(function () {
    if (isolated) {
      return null;
    }
    return isJoy ? extendTheme() : createTheme({
      colorSchemes: {
        light: true,
        dark: true
      },
      cssVariables: {
        colorSchemeSelector: 'data-mui-color-scheme'
      }
    });
  }, [isJoy, isolated]);
  return /*#__PURE__*/_jsx(StyleSheetManager, {
    target: document.head,
    stylisPlugins: theme.direction === 'rtl' ? [rtlPlugin] : [],
    children: /*#__PURE__*/_jsxs(CacheProvider, {
      value: cache,
      children: [iframeTheme && /*#__PURE__*/_jsx(GlobalStyles, {
        styles: ((_iframeTheme$generate = iframeTheme.generateStyleSheets) == null ? void 0 : _iframeTheme$generate.call(iframeTheme)) || []
      }), /*#__PURE__*/React.cloneElement(children, {
        window: getWindow
      }), isJoy && /*#__PURE__*/_jsx(JoyIframeObserver, {
        document: document,
        isolated: isolated
      })]
    })
  });
}
false ? void 0 : void 0;
var Iframe = styled('iframe')(function (_ref2) {
  var _ref3;
  var theme = _ref2.theme;
  return {
    backgroundColor: (theme.vars || theme).palette.background["default"],
    flexGrow: 1,
    height: 400,
    border: 0,
    boxShadow: (_ref3 = theme.vars || theme) == null || (_ref3 = _ref3.shadows) == null ? void 0 : _ref3[1]
  };
});
function DemoIframe(props) {
  var _frameRef$current;
  var children = props.children,
    name = props.name,
    isJoy = props.isJoy,
    isolated = props.isolated,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  /**
   * @type {import('react').Ref<HTMLIFrameElement>}
   */
  var frameRef = React.useRef(null);

  // If we portal content into the iframe before the load event then that content
  // is dropped in firefox.
  var _React$useReducer = React.useReducer(function () {
      return true;
    }, false),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    iframeLoaded = _React$useReducer2[0],
    onLoad = _React$useReducer2[1];
  React.useEffect(function () {
    var document = frameRef.current.contentDocument;
    // When we hydrate the iframe then the load event is already dispatched
    // once the iframe markup is parsed (maybe later but the important part is
    // that it happens before React can attach event listeners).
    // We need to check the readyState of the document once the iframe is mounted
    // and "replay" the missed load event.
    // See https://github.com/facebook/react/pull/13862 for ongoing effort in React
    // (though not with iframes in mind).
    if (document != null && document.readyState === 'complete' && !iframeLoaded) {
      onLoad();
    }
  }, [iframeLoaded]);
  var document = (_frameRef$current = frameRef.current) == null ? void 0 : _frameRef$current.contentDocument;
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [/*#__PURE__*/_jsx(Iframe, _extends({
      onLoad: onLoad,
      ref: frameRef,
      title: "".concat(name, " demo")
    }, other)), iframeLoaded !== false ? /*#__PURE__*/ReactDOM.createPortal(/*#__PURE__*/_jsx(FramedDemo, {
      document: document,
      isJoy: isJoy,
      isolated: isolated,
      children: children
    }), document.body) : null]
  });
}
false ? void 0 : void 0;
function IsolatedDemo(_ref4) {
  var children = _ref4.children,
    cssVarPrefix = _ref4.cssVarPrefix,
    colorSchemeNode = _ref4.colorSchemeNode,
    window = _ref4.window;
  return /*#__PURE__*/React.cloneElement(children, {
    window: window,
    cssVarPrefix: cssVarPrefix,
    colorSchemeNode: window ? window().document.documentElement : colorSchemeNode,
    colorSchemeSelector: 'class',
    documentNode: window ? window().document : undefined,
    disableNestedContext: true,
    storageManager: null
  });
}
false ? void 0 : void 0;

/**
 * Isolates the demo component as best as possible. Additional props are spread
 * to an `iframe` if `iframe={true}`.
 */
function DemoSandbox(props) {
  var children = props.children,
    _props$iframe = props.iframe,
    iframe = _props$iframe === void 0 ? false : _props$iframe,
    id = props.id,
    name = props.name,
    onResetDemoClick = props.onResetDemoClick,
    isJoy = props.isJoy,
    isolated = props.isolated,
    other = _objectWithoutPropertiesLoose(props, _excluded2);
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    injectTheme = _React$useState2[0],
    setInjectTheme = _React$useState2[1];
  var _React$useState3 = React.useState(),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    root = _React$useState4[0],
    setRoot = _React$useState4[1];
  React.useEffect(function () {
    setRoot(document.getElementById(id));
  }, [id]);
  var t = useTranslate();
  useEnhancedEffect(function () {
    function setupMaterialUITheme() {
      return _setupMaterialUITheme.apply(this, arguments);
    }
    function _setupMaterialUITheme() {
      _setupMaterialUITheme = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var jsx;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(typeof window.getInjectTheme === 'function')) {
                _context.next = 9;
                break;
              }
              if (globalInjectThemeCache) {
                _context.next = 8;
                break;
              }
              window.React = React;
              _context.next = 5;
              return import('react/jsx-runtime');
            case 5:
              jsx = _context.sent;
              window.jsx = jsx;
              globalInjectThemeCache = window.getInjectTheme();
            case 8:
              setInjectTheme(globalInjectThemeCache);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _setupMaterialUITheme.apply(this, arguments);
    }
    setupMaterialUITheme();
  }, []);
  return /*#__PURE__*/_jsx(DemoErrorBoundary, {
    name: name,
    onResetDemoClick: onResetDemoClick,
    t: t,
    children: isolated ?
    /*#__PURE__*/
    // Place ThemeProvider from MUI System here to disconnect the theme inheritance for Material UI and Joy UI
    // The demo will need to handle the ThemeProvider itself.
    _jsx(SystemThemeProvider, {
      theme: function theme(upperTheme) {
        return {
          direction: upperTheme.direction,
          // required for internal ThemeProvider
          vars: upperTheme.vars // required for styling Iframe
        };
      },
      children: iframe ? /*#__PURE__*/_jsx(DemoIframe, _extends({
        name: name,
        isJoy: isJoy,
        isolated: isolated
      }, other, {
        children: /*#__PURE__*/_jsx(IsolatedDemo, {
          cssVarPrefix: name,
          children: children
        })
      })) : /*#__PURE__*/_jsx(IsolatedDemo, {
        cssVarPrefix: name,
        colorSchemeNode: root,
        children: children
      })
    }) : /*#__PURE__*/_jsx(DemoInstanceThemeProvider, {
      runtimeTheme: injectTheme,
      children: iframe ? /*#__PURE__*/_jsx(DemoIframe, _extends({
        name: name,
        isJoy: isJoy
      }, other, {
        children: children
      })) : children
    })
  });
}
false ? void 0 : void 0;
export default /*#__PURE__*/React.memo(DemoSandbox);